import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import FileSaver from 'file-saver';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import InvDoc01Actions, { InvDoc01Types } from '../Stores/InvDoc01/Actions';

const getAppStore = state => state.app;

export function* invDoc01FetchInvDoc01({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(InvDoc01Actions.invDoc01FetchInvDoc01Loading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `invDoc/indexProcess/INV_DOC_01/${app.curSiteFlowId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        InvDoc01Actions.invDoc01FetchInvDoc01Success(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(InvDoc01Actions.invDoc01FetchInvDoc01Loading(false));
  }
}

export function* invDoc01CreateInvDoc01({ hdrIds }) {
  try {
    yield put(InvDoc01Actions.invDoc01CreateInvDoc01Loading(true));

    const app = yield select(getAppStore);

    const postData = {
      hdrIds
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `invDoc/createProcess/INV_DOC_01`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(InvDoc01Actions.invDoc01CreateInvDoc01Success(result.data));

      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(InvDoc01Actions.invDoc01CreateInvDoc01Loading(false));
  }
}

export function* invDoc01GoToOrderDoc({ hdrId, itemId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/outbOrdDetail/update/${hdrId}/${itemId}`));
}

export function* invDoc01ExcelOutbOrdDtls({ hdrIds }) {
  try {
    yield put(InvDoc01Actions.invDoc01CreateInvDoc01Loading(true));

    const app = yield select(getAppStore);

    const getData = {
      hdrIds
    };

    const result = yield call(
      ApiService.downloadGetApi, // function
      app.apiUrl,
      `pickList/excelOutbOrdDtls/${app.curSiteFlowId}`,
      app.token,
      getData,
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    );

    if (result.isSuccess === true) {
      FileSaver.saveAs(result.data, 'PICK_LIST_OUTB_ORD_DTLS.XLSX');
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(InvDoc01Actions.invDoc01CreateInvDoc01Loading(false));
  }
}

export const saga = [
  takeLatest(InvDoc01Types.INV_DOC01_FETCH_INV_DOC01, invDoc01FetchInvDoc01),
  takeLatest(InvDoc01Types.INV_DOC01_CREATE_INV_DOC01, invDoc01CreateInvDoc01),
  takeLatest(InvDoc01Types.INV_DOC01_GO_TO_ORDER_DOC, invDoc01GoToOrderDoc),
  takeLatest(InvDoc01Types.INV_DOC01_EXCEL_OUTB_ORD_DTLS, invDoc01ExcelOutbOrdDtls)
];
